/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntrySummary } from './EntrySummary';
import {
    EntrySummaryFromJSON,
    EntrySummaryFromJSONTyped,
    EntrySummaryToJSON,
    EntrySummaryToJSONTyped,
} from './EntrySummary';
import type { LuBill } from './LuBill';
import {
    LuBillFromJSON,
    LuBillFromJSONTyped,
    LuBillToJSON,
    LuBillToJSONTyped,
} from './LuBill';
import type { Invoice } from './Invoice';
import {
    InvoiceFromJSON,
    InvoiceFromJSONTyped,
    InvoiceToJSON,
    InvoiceToJSONTyped,
} from './Invoice';
import type { PatientDocumentVersion } from './PatientDocumentVersion';
import {
    PatientDocumentVersionFromJSON,
    PatientDocumentVersionFromJSONTyped,
    PatientDocumentVersionToJSON,
    PatientDocumentVersionToJSONTyped,
} from './PatientDocumentVersion';
import type { DocumentGroup } from './DocumentGroup';
import {
    DocumentGroupFromJSON,
    DocumentGroupFromJSONTyped,
    DocumentGroupToJSON,
    DocumentGroupToJSONTyped,
} from './DocumentGroup';

/**
 * Resolved PatientDocument embedded inside DocCcl
 * @export
 * @interface PatientDocument
 */
export interface PatientDocument {
    /**
     * 
     * @type {number}
     * @memberof PatientDocument
     */
    patientDocumentId: number;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    originalText: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    templateStatus: string;
    /**
     * 
     * @type {string}
     * @memberof PatientDocument
     */
    healthProType?: string;
    /**
     * 
     * @type {Date}
     * @memberof PatientDocument
     */
    findingStartDateTime?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PatientDocument
     */
    findingEndDateTime?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof PatientDocument
     */
    financialGroupId?: number;
    /**
     * 
     * @type {DocumentGroup}
     * @memberof PatientDocument
     */
    documentGroup?: DocumentGroup;
    /**
     * 
     * @type {EntrySummary}
     * @memberof PatientDocument
     */
    entry?: EntrySummary;
    /**
     * 
     * @type {Invoice}
     * @memberof PatientDocument
     */
    invoice?: Invoice;
    /**
     * 
     * @type {LuBill}
     * @memberof PatientDocument
     */
    luBill?: LuBill;
    /**
     * 
     * @type {Array<PatientDocumentVersion>}
     * @memberof PatientDocument
     */
    versions?: Array<PatientDocumentVersion>;
}

/**
 * Check if a given object implements the PatientDocument interface.
 */
export function instanceOfPatientDocument(value: object): value is PatientDocument {
    if (!('patientDocumentId' in value) || value['patientDocumentId'] === undefined) return false;
    if (!('originalText' in value) || value['originalText'] === undefined) return false;
    if (!('templateStatus' in value) || value['templateStatus'] === undefined) return false;
    return true;
}

export function PatientDocumentFromJSON(json: any): PatientDocument {
    return PatientDocumentFromJSONTyped(json, false);
}

export function PatientDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'patientDocumentId': json['patientDocumentId'],
        'originalText': json['originalText'],
        'templateStatus': json['templateStatus'],
        'healthProType': json['healthProType'] == null ? undefined : json['healthProType'],
        'findingStartDateTime': json['findingStartDateTime'] == null ? undefined : (new Date(json['findingStartDateTime'])),
        'findingEndDateTime': json['findingEndDateTime'] == null ? undefined : (new Date(json['findingEndDateTime'])),
        'financialGroupId': json['financialGroupId'] == null ? undefined : json['financialGroupId'],
        'documentGroup': json['documentGroup'] == null ? undefined : DocumentGroupFromJSON(json['documentGroup']),
        'entry': json['entry'] == null ? undefined : EntrySummaryFromJSON(json['entry']),
        'invoice': json['invoice'] == null ? undefined : InvoiceFromJSON(json['invoice']),
        'luBill': json['luBill'] == null ? undefined : LuBillFromJSON(json['luBill']),
        'versions': json['versions'] == null ? undefined : ((json['versions'] as Array<any>).map(PatientDocumentVersionFromJSON)),
    };
}

export function PatientDocumentToJSON(json: any): PatientDocument {
    return PatientDocumentToJSONTyped(json, false);
}

export function PatientDocumentToJSONTyped(value?: PatientDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientDocumentId': value['patientDocumentId'],
        'originalText': value['originalText'],
        'templateStatus': value['templateStatus'],
        'healthProType': value['healthProType'],
        'findingStartDateTime': value['findingStartDateTime'] == null ? undefined : ((value['findingStartDateTime'] as any).toISOString()),
        'findingEndDateTime': value['findingEndDateTime'] == null ? undefined : ((value['findingEndDateTime'] as any).toISOString()),
        'financialGroupId': value['financialGroupId'],
        'documentGroup': DocumentGroupToJSON(value['documentGroup']),
        'entry': EntrySummaryToJSON(value['entry']),
        'invoice': InvoiceToJSON(value['invoice']),
        'luBill': LuBillToJSON(value['luBill']),
        'versions': value['versions'] == null ? undefined : ((value['versions'] as Array<any>).map(PatientDocumentVersionToJSON)),
    };
}

